import React from 'react'

const OrderAdd = () => {
	return <div></div>
}

export default OrderAdd
